import { RouteRecordRaw } from 'vue-router';

import { useSystemSettingStore } from '@/store';

// 商品券関連
export const giftRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Gift',
    component: () => import('@/components/pages/gift/gift/index.vue'),
    path: '/gift',
    meta: {
      title: 'デジタル商品券',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftDetail',
    component: () => import('@/components/pages/gift/gift/detail/index.vue'),
    path: '/gift/:id',
    meta: {
      title: 'デジタル商品券詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftSet',
    component: () => import('@/components/pages/gift/gift-set/index.vue'),
    path: '/gift-set',
    meta: {
      title: '商品券セット',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftSetDetail',
    component: () => import('@/components/pages/gift/gift-set/detail/index.vue'),
    path: '/gift-set/:id',
    meta: {
      title: '商品券セット詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
];
